export default __webpack_public_path__ + "static/875-c7d0289d1ade503abe60860614da9aec.gif";